import React from 'react';
import { Option } from './option/view.tsx';
import { FieldOptions as FieldOptionsView, type Props } from './view.tsx';

export type OwnProps = Omit<Props, 'OptionComponent'>;

export const FieldOptions = (props: OwnProps) => (
	<FieldOptionsView {...props} OptionComponent={Option} />
);
